












































































import { AvisDePrelevement } from "../../models/AvisDePrelevement";
import { Contact } from "../../models/Contact";
import moment from "moment";
import NumeralInput from "../../core/Forms/NumeraInput.vue";
import TextInput from "../../core/Forms/TextInput.vue";
import TextareaInput from "../../core/Forms/TextareaInput.vue";
import ContactSelect from "../../core/Forms/ContactSelect.vue";

export default {
    name: "AvisDePrelevementModalEdit",
    components: { ContactSelect, TextareaInput, TextInput, NumeralInput },
    props: {
        avisDePrelevement: AvisDePrelevement,
    },
    data() {
        return {
            date: null,
            dateEmission: null,
            contactSelectFilters: [Contact.EType.Fournisseur],
        };
    },
    created() {
        this.initDates();
    },
    methods: {
        initDates() {
            if (this.avisDePrelevement.date) {
                this.date = new Date(this.avisDePrelevement.date);
            }
            if (this.avisDePrelevement.date_emission) {
                this.dateEmission = new Date(
                    this.avisDePrelevement.date_emission
                );
            }
        },
        updateDate(date) {
            this.avisDePrelevement.date = moment(date).format("YYYY-MM-DD");
        },
        updateDateEmission(date) {
            this.avisDePrelevement.date_emission =
                moment(date).format("YYYY-MM-DD");
        },
    },
    watch: {
        avisDePrelevement: {
            immediate: true,
            handler() {
                this.initDates();
            },
        },
    },
};
